import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight, TrendingUp, Trophy, Users } from 'lucide-react';

const News = () => {
  const news = [
    {
      id: 'nouvelles-reglementations-anj-2025',
      title: 'Nouvelles réglementations ANJ : ce qui change en 2025',
      excerpt: 'L\'Autorité Nationale des Jeux annonce de nouvelles mesures pour renforcer la protection des joueurs et améliorer la transparence des opérateurs.',
      date: '25.11.2025',
      category: 'Réglementation',
      icon: TrendingUp,
      color: 'bg-blue-100 text-blue-600',
    },
    {
      id: 'tendances-paris-sportifs-2025-2026',
      title: 'Les tendances des paris sportifs pour la saison 2025-2026',
      excerpt: 'Analyse des sports les plus populaires et des nouveaux marchés qui attirent les parieurs français cette saison.',
      date: '24.11.2025',
      category: 'Tendances',
      icon: Trophy,
      color: 'bg-yellow-100 text-yellow-600',
    },
    {
      id: 'operateurs-ameliorent-experience-mobile',
      title: 'Comment les opérateurs améliorent l\'expérience mobile',
      excerpt: 'Focus sur les innovations technologiques qui rendent les applications de paris plus rapides et intuitives pour les utilisateurs.',
      date: '23.11.2025',
      category: 'Technologie',
      icon: Users,
      color: 'bg-green-100 text-green-600',
    },
  ];

  return (
    <section id="actualites" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Actualités et analyses
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Restez informé des dernières nouveautés, réglementations et tendances du secteur
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {news.map((item, index) => {
            const Icon = item.icon;
            return (
              <article
                key={item.id}
                itemScope
                itemType="https://schema.org/NewsArticle"
                className={`bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border-2 border-gray-100 ${
                  index === 0 ? 'md:col-span-1' : ''
                }`}
              >
                {/* Image */}
                <div className="h-48 relative overflow-hidden">
                  <img 
                    src={index === 0 ? "/images/courtney-schroedel-v1SS8Wiz-uI-unsplash.webp" : index === 1 ? "/images/fauzan-saari-AmhdN68wjPc-unsplash.webp" : "/images/guzman-barquin-GQmYqY2ySLg-unsplash.webp"} 
                    alt={item.title}
                    itemProp="image"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black/20"></div>
                  <div className="absolute top-4 left-4">
                    <span className={`inline-flex items-center space-x-1 px-3 py-1 rounded-full text-xs font-semibold ${item.color} backdrop-blur-sm bg-white/90`}>
                      <Icon size={14} />
                      <span>{item.category}</span>
                    </span>
                  </div>
                </div>

                <div className="p-6">
                  <div className="flex items-center text-sm text-gray-500 mb-3">
                    <Calendar size={16} className="mr-2" />
                    <time itemProp="datePublished" dateTime={item.date.split('.').reverse().join('-')}>{item.date}</time>
                  </div>

                  <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight" itemProp="headline">
                    {item.title}
                  </h3>

                  <p className="text-gray-600 mb-4 leading-relaxed line-clamp-3" itemProp="description">
                    {item.excerpt}
                  </p>

                  <Link
                    to={`/news/${item.id}`}
                    data-discover="true"
                    className="inline-flex items-center text-primary-red font-semibold hover:text-primary-red-dark transition-colors"
                  >
                    Lire la suite
                    <ArrowRight className="ml-2" size={18} />
                  </Link>
                </div>
              </article>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/news"
            data-discover="true"
            className="inline-flex items-center bg-primary-red text-white px-8 py-3 rounded-lg font-semibold hover:bg-primary-red-dark transition-colors"
          >
            Voir toutes les actualités
            <ArrowRight className="ml-2" size={20} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default News;

